import React from 'react'
import { connect } from 'react-redux'
import * as XLSX from "xlsx"
import {getJsDateFromExcel} from "excel-date-to-js"
import { Form, Grid, Header, Button } from 'semantic-ui-react'
import {FormValidation, Field, FileBase64} from '../components'
import { fields } from '../../common/lib/redux-fields'
import {createDriver, loadDrivers, importDrivers} from '../../common/drivers/actions'
import { validateImport } from '../../common/drivers/validations'
import { genders } from '../../common/config'
import { loadCompanies } from '../../common/companies/actions'
import {objectKeysToLowercase, objectKeysWebalize} from "../../common/lib/utils";
import {lists} from "../../common/lib/redux-lists";
import {webalize} from "webalize";
import Alert from "../components/Alert";

const { Row, Column } = Grid

class DriversImportForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {selectedFileBase64Content: null, driversFromFile: [], driversAlreadyExist: [] }
  }

  componentWillMount() {
    this.props.loadCompanies({ sort: 'nameSort' })
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  newImport(e) {
    e.preventDefault()
    document.location.reload()
  }

  async submit(e) {
    e.preventDefault()

    const { fields, importDrivers, drivers } = this.props
    const { selectedFileBase64Content } = this.state

    const KEY_FIRSTNAME = "jmeno"
    const KEY_LASTNAME = "prijmeni"
    const KEY_GENDER = "pohlavi"
    const KEY_BIRTHDATE = "datum-narozeni"
    const KEY_EMAIL = "email"
    const KEY_PHONE = "telefon"

    if (fields.company.value && selectedFileBase64Content) {
        const workbook = XLSX.read(selectedFileBase64Content.split(',')[1], {type: "base64"});
        const driversFromFile = []
        workbook.SheetNames.forEach((sheetName) => {
          XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]).forEach((row) => {
            driversFromFile.push(objectKeysWebalize(objectKeysToLowercase(row)))
          })
        })

        const driversWillBeCreated = []
        const driversAlreadyExist = []

        driversFromFile.forEach((driverFromFile) => {
          let key = driverNameKey({firstName: driverFromFile[KEY_FIRSTNAME], lastName: driverFromFile[KEY_LASTNAME]})

          let driver = {
            firstName: driverFromFile[KEY_FIRSTNAME],
            lastName: driverFromFile[KEY_LASTNAME],
            gender: `${driverFromFile[KEY_GENDER] === genders.MALE ? '' : 'FE'}MALE`,
            birthdate: driverFromFile[KEY_BIRTHDATE] ? getJsDateFromExcel(driverFromFile[KEY_BIRTHDATE]).toISOString() : '1900-01-01',
            email: driverFromFile[KEY_EMAIL] || '',
            phoneNumber: driverFromFile[KEY_PHONE] || '',
            company: fields.company.value
          }

          // driver already exists
          if (drivers[key]) {
            driversAlreadyExist.push(driver)
          }
          else {
            driversWillBeCreated.push(driver)
          }
        })

        this.state.driversFromFile = driversFromFile
        this.state.driversAlreadyExist = driversAlreadyExist

        importDrivers(driversWillBeCreated)

        fields.$reset()
    }
  }

  downloadAsExcel = (e) => {
    const table_elt = document.getElementById(e.target.dataset.tbl);
    const workbook = XLSX.utils.table_to_book(table_elt);

    XLSX.writeFile(workbook, `potencialni-duplicity-z-importu-ridicu_${new Date().toISOString()}.xlsx`);
  }

  uploadHandler = (e) => {
    this.setState({selectedFileBase64Content: e.base64})
  }

  render() {
    const { fields, companyOptions, submitting, drivers, importErrors, driversImported } = this.props
    const { driversFromFile, driversAlreadyExist } = this.state

    console.log("drivers from file", driversFromFile)
    console.log("drivers exist", driversAlreadyExist)
    console.log("import errors", importErrors)

    return (
      Object.keys(drivers).length > 0 && companyOptions.length > 0 &&

      <Form loading={submitting} size="big">

        <Grid>
          <Row>
            <Column>
              <Header as="h2">Definice importu</Header>
            </Column>
          </Row>


          <Alert type={'info'}
                   message={'První řádek souboru musí obsahovat popisky sloupců: Jméno, Příjmení, Email, Telefon, Pohlaví, Datum narození. Na pořadí sloupců nezáleží. Soubor musí obsahovat minimálně jméno, příjmení a pohlaví. Email, telefon a datum narození nejsou při importu povinné.'}></Alert>

          {driversFromFile.length === 0 &&
            <Field label="Dopravce" type="select" {...fields.company} options={companyOptions} required />
          }
          {driversFromFile.length === 0 &&
            <FileBase64 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onDone={(e)=>this.uploadHandler(e)}></FileBase64>
          }
        </Grid>

        {driversFromFile.length === 0 &&
        <Grid>
          <Row>
            <Column>
              <Button type="submit" color="red" onClick={(e) => this.submit(e)}>Importovat</Button>
            </Column>
          </Row>
        </Grid>
        }

        {driversFromFile.length > 0 &&
          <Grid>
            <Row>
              <Column>
                <Header as="h3">Výsledek importu:</Header>
              </Column>
            </Row>
            {importErrors.length === 0 &&
              <Row>
                <Column>
                  <Alert type={'success'} message={'Soubor byl úspěšně zpracován.'}></Alert>
                </Column>
              </Row>
            }
            {driversAlreadyExist.length > 0 && importErrors.length === 0 &&
              <Row>
                <Column>
                  <h4 className="h4-drivers-import-result">Potenciální duplicity (při importu vynecháno):</h4>
                  <Button type="button" color="red" data-tbl="driver-import-duplicates" onClick={(e) => this.downloadAsExcel(e)}>Stáhnout v excelu</Button>

                  <table className="tbl-drivers-import-result" id="driver-import-duplicates">
                    <thead>
                    <tr>
                      <th>Jméno</th>
                      <th>Příjmení</th>
                      <th>Pohlaví</th>
                      <th>Datum narození</th>
                      <th>Email</th>
                      <th>Telefon</th>
                    </tr>
                    </thead>
                    <tbody>
                    {driversAlreadyExist.map((dr, i) => {
                      return (<tr key={i}>
                        <td>{dr.firstName}</td>
                        <td>{dr.lastName}</td>
                        <td>{genders[dr.gender]}</td>
                        <td>{new Date(dr.birthdate).toLocaleDateString()}</td>
                        <td>{dr.email}</td>
                        <td>{dr.phoneNumber}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                </Column>
              </Row>
            }
            {driversImported.length > 0 && importErrors.length === 0 &&
              <Row>
                <Column>
                  <h4 className="h4-drivers-import-result">Importovaní řidiči:</h4>

                  <table className="tbl-drivers-import-result">
                    <thead>
                    <tr>
                      <th>Jméno</th>
                      <th>Příjmení</th>
                      <th>Pohlaví</th>
                      <th>Datum narození</th>
                      <th>Email</th>
                      <th>Telefon</th>
                    </tr>
                    </thead>
                    <tbody>
                    {driversImported.map((dr, i) => {
                      return (<tr key={i}>
                        <td>{dr.firstName}</td>
                        <td>{dr.lastName}</td>
                        <td>{genders[dr.gender]}</td>
                        <td>{new Date(dr.birthdate).toLocaleDateString()}</td>
                        <td>{dr.email}</td>
                        <td>{dr.phoneNumber}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                </Column>
              </Row>
            }
            {importErrors.length > 0 &&
              <Row>
                <Column>
                  <Alert type={'error'} message={'Při importu došlo k chybě, nebyl naimportován žádný záznam. Detaily jsou uvedeny v následující tabulce.'}></Alert>
                  <table className="tbl-drivers-import-result">
                    <tbody>
                    {importErrors.map((err, i) => {
                      return (<tr key={i}>
                        <td>{err.toString()}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                </Column>
              </Row>
            }

            <Row>
              <Column>
                <Button type="submit" color="red" onClick={(e) => this.newImport(e)}>Nový import</Button>
              </Column>
            </Row>
          </Grid>
        }
      </Form>
    )
  }
}

DriversImportForm.defaultProps = {
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

DriversImportForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  attendSource: React.PropTypes.string,
  role: React.PropTypes.string.isRequired,
  errors: React.PropTypes.array,
  companyOptions: React.PropTypes.array.isRequired,
  loadCompanies: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
  loadDrivers: React.PropTypes.func.isRequired,
  createDriver: React.PropTypes.func.isRequired
}

DriversImportForm = fields(DriversImportForm, {
  path: 'DriversImportForm',
  fields: [
    'company'
  ],
  getInitialState: (props) => {
    return {selectedFileBase64Content: null, driversFromFile: [], driversAlreadyExist: []}
  }
})

DriversImportForm = lists(DriversImportForm, {
  path: 'DriversImportForm',
  debounceTime: 50,
  limit: 1e6,
  loadDataAction: (props) => (props.loadDrivers),
})

DriversImportForm = FormValidation(DriversImportForm, (props) => {
  console.log("validation")
  return { validateImport }
})

const driverNameKey = driver => {
  return webalize(driver.firstName + "_" + driver.lastName)
}

const driversToObj = (drivers) => {
  const obj = {}

  drivers.forEach(driver => {
    let key = driverNameKey(driver)
    obj[key] = obj[key] || [];
    obj[key].push({id: driver._id, firstName: driver.firstName, lastName: driver.lastName, gender: driver.gender, birthDate: driver.birthDate})
  })

  return obj
}

export default connect((state) => ({
  companyOptions: state.companies.all.map(c => ({ value: c._id, text: c.name })).toArray(),
  drivers: driversToObj(state.drivers.all),
  importErrors: state.drivers.importErrors.map(c => ( c.name )).toArray(),
  driversImported: state.drivers.imported.map(c => ({
    id: c._id,
    firstName: c.firstName,
    lastName: c.lastName,
    gender: c.gender,
    birthdate: c.birthdate,
    email: c.email,
    phoneNumber: c.phoneNumber })).toArray(),
  viewer: state.users.viewer,
}), { createDriver, loadDrivers, loadCompanies, importDrivers })(DriversImportForm)



// WEBPACK FOOTER //
// ./src/browser/forms/DriversImport.js